<div class="input-field">
    <input [type]="inputType || 'text'" [disabled]="disabled" #input>
    <label [for]="id" [ngClass]="{'empty': !empty$ || (empty$ | async)}">{{label}}</label>
</div>